import { ArcadePage, type ArcadeSpec } from "./ArcadeShell";
import { tk } from "../../../../lib/i18n";

const SPEC: ArcadeSpec = {
  id: "lari", title: tk("Lari Kuiz"), tone: "from-emerald-500 to-teal-600", emoji: "🏃", w: 360, h: 520, mascot: true,
  intro: tk("Lari bersama Harraz atau Hannah! Lari di bawah papan jawapan yang betul. Lompat atau tukar lorong untuk elak timbunan buku."),
  hint: tk("Sentuh kiri, tengah atau kanan untuk tukar lorong. Leret ke atas untuk lompat."),
  load: async () => (await import("./engines/lari3d")).createLari3d,
};
export const LariKuizPage = () => <ArcadePage spec={SPEC} />;
